// extracted by mini-css-extract-plugin
export default {"con":"acceptedprojectStyles_con__UxRh+","table":"acceptedprojectStyles_table__LLRZr","image":"acceptedprojectStyles_image__yW2-8"};